import { useMemo } from 'react';
import { ponticOption, questions } from '../../Question';
import { useLang } from '../../../../util/lang';
import { useSelector } from 'react-redux';

const usePonticOption = ({ selectedRetainerType = '', question = questions }) => {
    const getDiffRetainerLang = useLang('DiffRetainer');
    const lang = useSelector((store) => store.lang);
    const memoPonticOption = useMemo(() => {
        const option = question.pontic.option || ponticOption;
        let optionsWithTranslatedLabel = option.map((opt) => {
            return {
                ...opt,
                label: getDiffRetainerLang(`formQuestionLabel.${opt.value}`),
            };
        });
        const baseOption = optionsWithTranslatedLabel.filter((opt) => opt.value !== 'sectionTheWireToIgnoreTheSpace');
        if (!selectedRetainerType || !selectedRetainerType.length) return baseOption;
        if (['ecodontRetainersWithWire', 'ecodontRetainerWithWire_1set'].includes(selectedRetainerType)) {
            return optionsWithTranslatedLabel.filter((v) => v.value !== 'ignore');
        }
        return baseOption;
    }, [selectedRetainerType, lang]);

    return {
        memoPonticOption,
    };
};

export default usePonticOption;
